import React from 'react'
import { SelectInput } from '../../lib'
import denominations from './denominations.json'

const DenominationInput = ({ onChange, autoFocus, ...rest }) => {
  return (
    <SelectInput
      {...rest}
      className='DenominationInput'
      autoFocus
      onChange={v => onChange(v, true)}>
      <option disabled selected hidden>Please choose...</option>
      {denominations.map(denomination => (
        <option value={denomination.value} key={denomination.value}>
          {denomination.label}
        </option>
      ))}
    </SelectInput>
  )
}

DenominationInput.displayName = 'DenominationInput'

export default DenominationInput



// WEBPACK FOOTER //
// ./src/assess/question/DenominationInput.js